/* The Mint Workshop — submission transition.
   Plays every time someone heads to the submission form (or another page in
   the theme setting's list): the card lifts off the button and lands on the
   mat. The overlay is handed across the page load, so the destination opens
   on the same mat and the form fades in from under it once it has drawn.
   Always fails open: if anything goes wrong the browser just follows the link,
   and the arriving overlay clears itself after a few seconds no matter what. */
(function () {
  'use strict';

  var el = document.querySelector('[data-mw-tx]');
  var root = document.documentElement;
  var HOLD = 'mw-tx-hold';
  var ARRIVE = 'mw-tx-arrive';

  function clearHold() { root.classList.remove(HOLD); }
  if (!el) { clearHold(); return; }

  var cfg = {
    enabled: el.dataset.enabled !== 'false',
    minMs: parseInt(el.dataset.min || '420', 10),
    maxMs: parseInt(el.dataset.max || '700', 10),
    match: (el.dataset.match || '').split(',').map(function (s) { return s.trim().replace(/\/+$/, ''); }).filter(Boolean)
  };
  /* Old addresses that Shopify redirects to the form still count as the form. */
  ['/pages/card-submission-form', '/pages/submit'].forEach(function (m) { if (cfg.match.indexOf(m) < 0) cfg.match.push(m); });

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var firing = false;

  function pathOf(href) {
    try { return new URL(href, location.href).pathname.replace(/\/+$/, '') || '/'; } catch (e) { return ''; }
  }
  function sameSite(href) {
    try { return new URL(href, location.href).origin === location.origin; } catch (e) { return false; }
  }
  /* Whole path segments only: /pages/submit must not catch /pages/submission-tracker. */
  function isTarget(href) {
    if (!href || /^(#|mailto:|tel:|javascript:)/i.test(href) || !sameSite(href)) return false;
    var p = pathOf(href);
    for (var i = 0; i < cfg.match.length; i++) {
      var m = cfg.match[i];
      if (p === m || p.indexOf(m + '/') === 0) return true;
    }
    return false;
  }

  var prefetched = {};
  function prefetch(href) {
    if (prefetched[href]) return;
    prefetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  }

  function go(href) {
    /* A timestamp, not the path: the address may redirect (old form links) before the form loads. */
    try { sessionStorage.setItem(ARRIVE, String(Date.now())); } catch (e) { /* private mode: plain arrival */ }
    if (window.__protoNavigate) window.__protoNavigate(href);
    else window.location.href = href;
  }

  function reset() {
    firing = false;
    el.classList.remove('is-active', 'is-held', 'is-leaving');
    el.setAttribute('aria-hidden', 'true');
  }

  function play(href, rect) {
    if (firing) return;
    firing = true;
    if (rect) {
      el.style.setProperty('--from-x', (rect.left + rect.width / 2) + 'px');
      el.style.setProperty('--from-y', (rect.top + rect.height / 2) + 'px');
    }
    el.classList.remove('is-held', 'is-leaving');
    el.classList.add('is-active');
    el.setAttribute('aria-hidden', 'false');
    setTimeout(function () { go(href); }, Math.max(cfg.minMs, 0));
    /* If the browser never leaves (blocked, offline), give the page back. */
    setTimeout(reset, cfg.maxMs + 4000);
  }

  /* For buttons that open the form from code: window.mwSubmitTransition('/pages/submit', button) */
  window.mwSubmitTransition = function (href, from) {
    if (!cfg.enabled || reduced) { window.location.href = href; return; }
    play(href, from && from.getBoundingClientRect ? from.getBoundingClientRect() : null);
  };

  function hrefOf(node) {
    var a = node.closest && node.closest('a[href], [data-href], button[formaction]');
    if (!a) return null;
    if (a.tagName === 'A') return a.target === '_blank' || a.hasAttribute('download') ? null : { el: a, href: a.getAttribute('href') };
    return { el: a, href: a.getAttribute('data-href') || a.getAttribute('formaction') };
  }

  document.addEventListener('pointerover', function (e) {
    var t = hrefOf(e.target);
    if (t && isTarget(t.href)) prefetch(t.href);
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (!cfg.enabled || reduced || firing) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var t = hrefOf(e.target);
    if (!t || !isTarget(t.href)) return;
    /* already on that page: nothing to transition to */
    if (pathOf(t.href) === pathOf(location.href)) return;
    e.preventDefault();
    e.stopPropagation();
    play(t.href, t.el.getBoundingClientRect());
  }, true);

  /* Back/forward cache: never come back to a page still covered by the mat. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { reset(); clearHold(); } });

  /* ---------------------------------------------------------------------------
     Arrival. The head script already put the plain mat up (html.mw-tx-hold) so
     the page never flashes. Swap it for the full overlay in its landed state,
     wait for the page to be ready, then fade it away. */
  var arriving = false;
  try {
    var at = parseInt(sessionStorage.getItem(ARRIVE) || '0', 10);
    arriving = at > 0 && Date.now() - at < 15000 && isTarget(location.href);
    sessionStorage.removeItem(ARRIVE);
  } catch (e) {}
  if (!arriving || reduced) { clearHold(); return; }

  el.classList.add('is-active', 'is-held');
  el.setAttribute('aria-hidden', 'false');
  clearHold();

  var t0 = Date.now(), done = false;
  function leave() {
    if (done) return;
    done = true;
    var wait = Math.max(0, 450 - (Date.now() - t0));   /* long enough to read, never a stall */
    setTimeout(function () {
      el.classList.add('is-leaving');
      setTimeout(reset, 420);
    }, wait);
  }
  /* The submission form draws inside a frame; it is ready once its app has content. */
  function ready() {
    var f = document.getElementById('mw-proto-frame');
    if (!f) return !document.getElementById('mw-proto') && document.readyState !== 'loading';
    try {
      var app = f.contentDocument && f.contentDocument.getElementById('app');
      return !!(app && app.children.length);
    } catch (e) { return true; }
  }
  (function poll() {
    if (done) return;
    if (ready()) return leave();
    if (Date.now() - t0 > 6000) return leave();          /* hard ceiling: never trap the page */
    setTimeout(poll, 60);
  })();
})();
